import React from 'react'
import Component from '../common/Component'
import BenefitsSetBulkEditsComponent from '../BenefitsSet/BenefitsSetBulkEditsComponent'
import { benefitLabels, metadatumFieldsBulkEdit } from './fields'

const benefitsReviewFields = {
  values: [
    'name',
    'sbc_rejected',
    'sbc_name',
    'network',
    'hsa_eligible',
    'level',
    'plan_type',
    'plan_calendar',
    'effective_date',
    'expiration_date',
    'embedded_deductible',
    'gated',
    'telemedicine',
    'drug_formulary_url',
    'mail_order_rx',
    'infertility_rider',
    'abortion_rider',
    'adult_dental',
    'chiropractic_services',
    'privileged_data',
    'individual_medical_deductible_in_network',
    'individual_medical_deductible_out_of_network',
    'family_medical_deductible_in_network',
    'family_medical_deductible_out_of_network',
    'individual_drug_deductible_in_network',
    'individual_drug_deductible_out_of_network',
    'family_drug_deductible_in_network',
    'family_drug_deductible_out_of_network',
    'individual_medical_moop_in_network',
    'individual_medical_moop_out_of_network',
    'family_medical_moop_in_network',
    'family_medical_moop_out_of_network',
    'individual_drug_moop_in_network',
    'individual_drug_moop_out_of_network',
    'family_drug_moop_in_network',
    'family_drug_moop_out_of_network',
    'plan_coinsurance_in_network',
    'plan_coinsurance_out_of_network',
    'primary_care_physician_in_network',
    'primary_care_physician_out_of_network',
    'specialist_in_network',
    'specialist_out_of_network',
    'preventative_care_in_network',
    'preventative_care_out_of_network',
    'diagnostic_test_in_network',
    'diagnostic_test_out_of_network',
    'lab_test_in_network',
    'lab_test_out_of_network',
    'imaging_center_in_network',
    'imaging_center_out_of_network',
    'imaging_physician_in_network',
    'imaging_physician_out_of_network',
    'generic_drugs_in_network',
    'generic_drugs_out_of_network',
    'generic_drugs_limit',
    'non_preferred_generic_drug_share_in_network',
    'non_preferred_generic_drug_share_out_of_network',
    'non_preferred_generic_drug_share_limit',
    'preferred_brand_drugs_in_network',
    'preferred_brand_drugs_out_of_network',
    'preferred_brand_drugs_limit',
    'non_preferred_brand_drugs_in_network',
    'non_preferred_brand_drugs_out_of_network',
    'non_preferred_brand_drugs_limit',
    'specialty_drugs_in_network',
    'specialty_drugs_out_of_network',
    'specialty_drugs_limit',
    'non_preferred_specialty_drug_share_in_network',
    'non_preferred_specialty_drug_share_out_of_network',
    'non_preferred_specialty_drug_share_limit',
    'outpatient_hospital_in_network',
    'outpatient_hospital_out_of_network',
    'outpatient_ambulatory_care_center_in_network',
    'outpatient_ambulatory_care_center_out_of_network',
    'outpatient_physician_in_network',
    'outpatient_physician_out_of_network',
    'emergency_room_in_network',
    'emergency_room_out_of_network',
    'emergency_room_limit',
    'ambulance_in_network',
    'ambulance_out_of_network',
    'urgent_care_in_network',
    'urgent_care_out_of_network',
    'inpatient_facility_in_network',
    'inpatient_facility_out_of_network',
    'inpatient_facility_limit',
    'inpatient_physician_in_network',
    'inpatient_physician_out_of_network',
    'outpatient_mental_health_in_network',
    'outpatient_mental_health_out_of_network',
    'inpatient_mental_health_in_network',
    'inpatient_mental_health_out_of_network',
    'outpatient_substance_in_network',
    'outpatient_substance_out_of_network',
    'inpatient_substance_in_network',
    'inpatient_substance_out_of_network',
    'prenatal_care_in_network',
    'prenatal_care_out_of_network',
    'postnatal_care_in_network',
    'postnatal_care_out_of_network',
    'inpatient_birth_physician_in_network',
    'inpatient_birth_physician_out_of_network',
    'inpatient_birth_in_network',
    'inpatient_birth_out_of_network',
    'home_health_care_in_network',
    'home_health_care_out_of_network',
    'home_health_care_limit',
    'rehabilitation_services_in_network',
    'rehabilitation_services_out_of_network',
    'rehabilitation_services_limit',
    'habilitation_services_in_network',
    'habilitation_services_out_of_network',
    'habilitation_services_limit',
    'skilled_nursing_in_network',
    'skilled_nursing_out_of_network',
    'skilled_nursing_limit',
    'durable_medical_equipment_in_network',
    'durable_medical_equipment_out_of_network',
    'durable_medical_equipment_limit',
    'hospice_service_in_network',
    'hospice_service_out_of_network',
    'hospice_service_limit',
    'child_eye_exam_in_network',
    'child_eye_exam_out_of_network',
    'child_eye_exam_limit',
    'child_eyewear_in_network',
    'child_eyewear_out_of_network',
    'child_eyewear_limit',
    'child_dental_in_network',
    'child_dental_out_of_network',
    'child_dental_limit'
  ],
  pinned: ['sbc_url', 'sbc_rejected']
}

const metadataReviewFields = {
  values: [
    'service_area_external_key',
    'hsa_eligible',
    'name',
    'level',
    'actuarial_value',
    'estimated_actuarial_value',
    'plan_type',
    'market',
    'plan_year',
    'effective_date',
    'expiration_date',
    'carrier_id',
    'issuer_name',
    'state_id',
    'audience',
    'plan_calendar',
    'infertility_rider',
    'abortion_rider',
    'privileged_data',
    'adult_dental',
    'chiropractic_services',
    'telemedicine',
    'actively_marketed',
    'private_exchange',
    'covered_ages',
    'skilled_nursing_facility_365',
    'dp_rider',
    'fp_rider',
    'age29_rider'
  ],
  pinned: ['sbc_url', 'sbc_rejected']
}

const highLevelSummaryFields = {
  values: [
    'infertility_rider',
    'abortion_rider',
    'privileged_data',
    'telemedicine',
    'adult_dental',
    'chiropractic_services',
    'estimated_actuarial_value',
    'actuarial_value',
    'level',
    'sbc_name',
    'name',
    'hsa_eligible',
    'individual_medical_deductible_in_network',
    'individual_drug_deductible_in_network',
    'individual_medical_moop_in_network',
    'primary_care_physician_in_network',
    'specialist_in_network',
    'generic_drugs_in_network',
    'specialty_drugs_in_network',
    'emergency_room_limit',
    'home_health_care_limit',
    'rehabilitation_services_limit',
    'habilitation_services_limit',
    'skilled_nursing_limit',
    'durable_medical_equipment_limit',
    'hospice_service_limit',
    'child_eye_exam_limit',
    'child_eyewear_limit',
    'child_dental_limit',
    'lab_test_in_network',
    'lab_test_in_network_tier_2',
    'lab_test_out_of_network',
    'imaging_center_in_network',
    'imaging_center_in_network_tier_2',
    'imaging_center_out_of_network',
    'outpatient_hospital_in_network',
    'outpatient_hospital_in_network_tier_2',
    'outpatient_hospital_out_of_network',
    'inpatient_facility_in_network',
    'inpatient_facility_in_network_tier_2',
    'inpatient_facility_out_of_network'
  ],
  pinned: ['sbc_url', 'sbc_rejected']
}

const networkOpsFields = {
  values: [
    'customer_document_id',
    'sbc_url',
    'vericred_id',
    'customer',
    'network',
    'network_unmapped_reason',
    'network_mapping_notes',
    'sbc_name',
    'issuer_name',
    'plan_type'
  ],
  pinned: [
    'customer_document_id', 'sbc_url', 'vericred_id',
    'customer', 'network', 'network_unmapped_reason', 'network_mapping_notes'
  ]
}

const presetFilters = {
  default: benefitsReviewFields,
  benefits_review: benefitsReviewFields,
  metadata_review: metadataReviewFields,
  high_level_summary: highLevelSummaryFields,
  network_ops: networkOpsFields
}

export default class LargeGroupCustomBenefitsSetBulkEditsComponent extends Component {
  render() {
    return (
      <BenefitsSetBulkEditsComponent
        benefitLabels={benefitLabels}
        metadatumFields={metadatumFieldsBulkEdit}
        defaultFields={presetFilters}
        benefitsSetUrl="/large_group_custom_benefits"
        productLine="large_group_custom"
        withSbc
        hideId
        includeSbcCheckbox
        {...this.props}
      />
    )
  }
}
